import { NgModule } from '@angular/core';

import { DeviceModule } from '@ap/tokens-browser';

import { LogoutModalModule } from '../logout-modal/logout-modal.module';

import { DeviceWrapperComponent } from './device.wrapper.component';

/**
 * @name DeviceWrapperModule
 * @ngdoc module
 */
@NgModule({
    declarations: [DeviceWrapperComponent],
    imports: [DeviceModule, LogoutModalModule],
    exports: [DeviceWrapperComponent]
})
export class DeviceWrapperModule {}
